import { useCandidateInterviews } from '@/hooks/use-candidates';
import type { InterviewScope } from '@/types/candidates';
import { CandidateInterviewItem } from './candidate-interview-item';

interface CandidateInterviewListProps {
  candidateId: string;
  scope: InterviewScope;
}

export function CandidateInterviewList({ candidateId, scope }: CandidateInterviewListProps) {
  const { data, isLoading, error } = useCandidateInterviews(candidateId, scope);
  const interviews = data ?? [];

  if (isLoading) {
    return <p className="text-sm text-muted-foreground">Loading…</p>;
  }
  if (error) {
    return <p className="text-sm text-destructive">Failed to load interviews.</p>;
  }
  if (interviews.length === 0) {
    return (
      <p className="text-sm text-muted-foreground">
        {scope === 'upcoming' ? 'No upcoming interviews.' : 'No interviews yet.'}
      </p>
    );
  }

  return (
    <div className="space-y-2">
      {interviews.map((interview) => (
        <CandidateInterviewItem
          key={interview.id}
          candidateId={candidateId}
          interview={interview}
        />
      ))}
    </div>
  );
}
